/**
 * body 要素に対して初期化処理を実行します。
 */
export function initBody() {
    // @ts-ignore
    const mtappVars = window.mtappVars;
    // クラスの追加
    document.body.classList.add(`mt-version-${parseInt(mtappVars.minor_version)}`, `theme-${mtappVars.admin_theme_id}`,  `blog-id-${mtappVars.blog_id}`, `author-id-${mtappVars.author_id}`, `screen-id-${mtappVars.screen_id}`);
}
